export const BINARY_FILENAME = 'output.bin';
